import { easepick } from '@easepick/core'
import { AmpPlugin } from '@easepick/amp-plugin'

  ; (($) => {
    $(() => {
      let module = $('#quote_form_private')

      // Only continue if module is on page
      if (!module.length) return

      const isOneItemRental = document.getElementById('isOneItemRental')?.value
      const startDateInput = document.getElementById('quote_form_private_fields_customerRentalStartDate')
      const endDateInput = document.getElementById('quote_form_private_fields_customerRentalEndDate')
      const quoteFormPrivateSubmit = document.getElementById('quote_form_private__submit')
      const today = new Date();
      today.setHours(0, 0, 0, 0);

      const errorSpan = document.createElement('span');
      errorSpan.className = 'error-message';

      const errorSpanEnd = document.createElement('span');
      errorSpanEnd.className = 'error-message';

      module.on('submit', function (e) {
        e.preventDefault()

        /* If cart has at least one rental product */
        if (isOneItemRental === 'true') {
          
          

          if (startDateInput != null) {
            const startDate = parseDateFromDDMMYYYY(startDateInput?.value?.trim());
            const existingStartError = startDateInput.parentNode.querySelector('.error-message');
            if (existingStartError) existingStartError.remove();
            const existingEndError = endDateInput.parentNode.querySelector('.error-message');
            if (existingEndError) existingEndError.remove();
            if (isNaN(new Date(startDate.getTime()))) {
              errorSpan.textContent = `${window.globals.trans('cart.quote.invalid_date')}`;
              errorSpan.style.display = 'inline-block';
              startDateInput.parentNode.insertBefore(errorSpan, startDateInput.nextSibling);
              startDateInput.value = '';
              endDateInput.value = '';
              setTimeout(() => {
                quoteFormPrivateSubmit.disabled = false;
              }, 2);
              return false;
            }
          }

          if (endDateInput != null) {
            const endDate = parseDateFromDDMMYYYY(endDateInput?.value?.trim());
            if (isNaN(new Date(endDate.getTime()))) {
              errorSpanEnd.textContent = `${window.globals.trans('cart.quote.invalid_date')}`;
              errorSpanEnd.style.display = 'inline-block';
              endDateInput.parentNode.insertBefore(errorSpanEnd, endDateInput.nextSibling);
              endDateInput.value = '';
              setTimeout(() => {
                quoteFormPrivateSubmit.disabled = false;
              }, 2);
              return false;
            }
          }

          if (startDateInput != null && endDateInput != null) {
            const startDate = parseDateFromDDMMYYYY(startDateInput?.value?.trim());
            const endDate = parseDateFromDDMMYYYY(endDateInput?.value?.trim());
            if (startDate < today) {
              errorSpan.textContent = `${window.globals.trans('cart.quote.rental_start_date_error')}`;
              errorSpan.style.display = 'inline-block';
              startDateInput.parentNode.insertBefore(errorSpan, startDateInput.nextSibling);
              startDateInput.value = '';
              endDateInput.value = '';
              setTimeout(() => {
                quoteFormPrivateSubmit.disabled = false;
              }, 2);
              return false;
            }
            if (startDate > endDate) {
              errorSpanEnd.textContent = `${window.globals.trans('cart.quote.rental_end_date_error')}`;
              errorSpanEnd.style.display = 'inline-block';
              endDateInput.parentNode.insertBefore(errorSpanEnd, endDateInput.nextSibling);
              endDateInput.value = '';
              setTimeout(() => {
                quoteFormPrivateSubmit.disabled = false;
              }, 2);
              return false;
            }
          }
        }

        // Recaptcha
        window.grecaptcha.reset()
        window.grecaptcha.execute(window.widgetPrivate)
      })

      // Hide or show date fields based on rental type
      if (isOneItemRental === 'false') {
        if (startDateInput != null && endDateInput != null) {
          startDateInput.parentElement.style.display = 'none'
          endDateInput.parentElement.style.display = 'none'

          startDateInput.removeAttribute('required')
          endDateInput.removeAttribute('required')
        }
      }

      function parseDateFromDDMMYYYY(str) {
        const [day, month, year] = str.split('/');
        const parsedDate = new Date(year, month - 1, day);
        return isNaN(parsedDate.getTime()) ? null : parsedDate;
      }

      function blockAllManualInput(field) {
        field.addEventListener('keydown', e => e.preventDefault());
        field.addEventListener('paste', e => e.preventDefault());
        field.addEventListener('drop', e => e.preventDefault());
      }

      const commonOptions = {
        css: [
          'https://cdn.jsdelivr.net/npm/@easepick/core@1.2.0/dist/index.css',
          '/',
        ],
        AmpPlugin: {
          dropdown: {
            months: true,
            years: true,
          },
          resetButton: true,
          darkMode: false,
        },
        zIndex: 9999,
        lang: document.querySelector('html')?.getAttribute('data-locale')?.replace('_', '-') || 'en',
        plugins: [AmpPlugin],
      }

      if (startDateInput != null) {
        // Create separate datepicker for Start Date
        new easepick.create({
          ...commonOptions,
          element: startDateInput,
          setup(picker) {
            picker.on('select', () => {
              const selectedDate = picker.getDate();

              // Remove existing error if any
              const existingStartError = startDateInput.parentNode.querySelector('.error-message');
              if (existingStartError) existingStartError.remove();

              // Check if it's before today
              if (selectedDate < today) {
                errorSpan.textContent = `${window.globals.trans('cart.quote.rental_start_date_error')}`;
                errorSpan.style.display = 'inline-block';
                startDateInput.parentNode.insertBefore(errorSpan, startDateInput.nextSibling);
                startDateInput.value = '';
                endDateInput.value = '';
                return;
              }

              // Format and display date as dd/mm/yyyy
              const day = String(selectedDate.getDate()).padStart(2, '0');
              const month = String(selectedDate.getMonth() + 1).padStart(2, '0');
              const year = selectedDate.getFullYear();
              startDateInput.value = `${day}/${month}/${year}`;
              console.log('/var/www/html/axel/backend/frontend/src/js/checkout/checkout-form.js DD/MM/YYYY: ',`${day}/${month}/${year}`);
            });
          },
        })
        startDateInput.removeAttribute('readonly')
        startDateInput.classList.add('calendar-icon');
        blockAllManualInput(startDateInput)
      }

      if (endDateInput != null) {
        // Create separate datepicker for End Date
        new easepick.create({
          ...commonOptions,
          element: endDateInput,
          setup(picker) {
            picker.on('select', () => {
              const selectedEndDate = picker.getDate();
              const start = parseDateFromDDMMYYYY(startDateInput.value);
              start.setHours(0, 0, 0, 0);

              if (picker.getDate() < start || start == 'Invalid Date') {
                endDateInput.parentNode.insertBefore(errorSpanEnd, endDateInput.nextSibling);
                errorSpanEnd.textContent = `${window.globals.trans('cart.quote.rental_end_date_error')}`;
                errorSpanEnd.style.display = 'inline-block';
                endDateInput.value = '';
                return false
              } else {
                const existingEndError = endDateInput.parentNode.querySelector('.error-message');
                if (existingEndError) existingEndError.remove();
              }

              // Format and display date as dd/mm/yyyy
              const day = String(selectedEndDate.getDate()).padStart(2, '0');
              const month = String(selectedEndDate.getMonth() + 1).padStart(2, '0');
              const year = selectedEndDate.getFullYear();
              endDateInput.value = `${day}/${month}/${year}`;
            })
          },
        })
        endDateInput.removeAttribute('readonly')
        endDateInput.classList.add('calendar-icon');
        blockAllManualInput(endDateInput)
      }
    })

    $(() => {
      let module = $('#quote_form_business')

      // Only continue if module is on page
      if (!module.length) return

      const isOneItemRental = document.getElementById('isOneItemRental')?.value
      const startDateInput = document.getElementById('quote_form_business_fields_customerRentalStartDate')
      const endDateInput = document.getElementById('quote_form_business_fields_customerRentalEndDate')
      const quoteFormBusinessSubmit = document.getElementById('quote_form_business__submit')
      const today = new Date();
      today.setHours(0, 0, 0, 0);

      const errorSpan = document.createElement('span');
      errorSpan.className = 'error-message';

      const errorSpanEnd = document.createElement('span');
      errorSpanEnd.className = 'error-message';

      module.on('submit', function (e) {
        e.preventDefault()

        /* If form has datepicker field */
        if (isOneItemRental === 'true') {
          if (startDateInput != null) {
            const startDate = parseDateFromDDMMYYYY(startDateInput?.value?.trim());
            const existingStartError = startDateInput.parentNode.querySelector('.error-message');
            if (existingStartError) existingStartError.remove();
            const existingEndError = endDateInput.parentNode.querySelector('.error-message');
            if (existingEndError) existingEndError.remove();
            if (isNaN(new Date(startDate.getTime()))) {
              errorSpan.textContent = `${window.globals.trans('cart.quote.invalid_date')}`;
              errorSpan.style.display = 'inline-block';
              startDateInput.parentNode.insertBefore(errorSpan, startDateInput.nextSibling);
              startDateInput.value = '';
              endDateInput.value = '';
              setTimeout(() => {
                quoteFormBusinessSubmit.disabled = false;
              }, 2);
              return false;
            }
          }

          if (endDateInput != null) {
            const endDate = parseDateFromDDMMYYYY(endDateInput?.value?.trim());
            if (isNaN(new Date(endDate.getTime()))) {
              errorSpanEnd.textContent = `${window.globals.trans('cart.quote.invalid_date')}`;
              errorSpanEnd.style.display = 'inline-block';
              endDateInput.parentNode.insertBefore(errorSpanEnd, endDateInput.nextSibling);
              endDateInput.value = '';
              setTimeout(() => {
                quoteFormBusinessSubmit.disabled = false;
              }, 2);
              return false;
            }
          }

          if (startDateInput != null && endDateInput != null) {
            const startDate = parseDateFromDDMMYYYY(startDateInput?.value?.trim());
            const endDate = parseDateFromDDMMYYYY(endDateInput?.value?.trim());
            if (startDate < today) {
              errorSpan.textContent = `${window.globals.trans('cart.quote.rental_start_date_error')}`;
              errorSpan.style.display = 'inline-block';
              startDateInput.parentNode.insertBefore(errorSpan, startDateInput.nextSibling);
              startDateInput.value = '';
              endDateInput.value = '';
              setTimeout(() => {
                quoteFormBusinessSubmit.disabled = false;
              }, 2);
              return false;
            }
            if (startDate > endDate) {
              errorSpanEnd.textContent = `${window.globals.trans('cart.quote.rental_end_date_error')}`;
              errorSpanEnd.style.display = 'inline-block';
              endDateInput.parentNode.insertBefore(errorSpanEnd, endDateInput.nextSibling);
              endDateInput.value = '';
              setTimeout(() => {
                quoteFormBusinessSubmit.disabled = false;
              }, 2);
              return false;
            }
          }
        }

        // GTM — rfq_submitted
        if (window.dataLayer && typeof window.dataLayer.push === 'function') {
          const products = []
          document.querySelectorAll('.cart-item').forEach(function (el) {
            if (!el.dataset.itemId) return
            const item = {
              item_id: el.dataset.itemId,
              item_name: el.dataset.itemName,
              quantity: parseFloat(el.dataset.itemQuantity) || 1,
            }
            if (el.dataset.requestType) item.request_type = el.dataset.requestType
            if (el.dataset.itemBrand) item.item_brand = el.dataset.itemBrand
            if (el.dataset.itemCategory) item.item_category = el.dataset.itemCategory
            if (el.dataset.itemCategory2) item.item_category2 = el.dataset.itemCategory2
            if (el.dataset.itemCategory3) item.item_category3 = el.dataset.itemCategory3
            products.push(item)
          })
          
          window.dataLayer.push({ ecommerce: null })
          window.dataLayer.push({
            event: 'rfq_submitted',
            ecommerce: {
              items: products
            }
          })
        }

        // Recaptcha
        window.grecaptcha.reset()
        window.grecaptcha.execute(window.widgetBusiness)
      })

      if (isOneItemRental === 'false') {
        if (startDateInput != null && endDateInput != null) {
          startDateInput.parentElement.style.display = 'none'
          endDateInput.parentElement.style.display = 'none'

          startDateInput.removeAttribute('required')
          endDateInput.removeAttribute('required')
        }
      }

      function parseDateFromDDMMYYYY(str) {
        const [day, month, year] = str.split('/');
        const parsedDate = new Date(year, month - 1, day);
        return isNaN(parsedDate.getTime()) ? null : parsedDate;
      }

      function blockAllManualInput(field) {
        field.addEventListener('keydown', e => e.preventDefault());
        field.addEventListener('paste', e => e.preventDefault());
        field.addEventListener('drop', e => e.preventDefault());
    }

      const commonOptions = {
        css: [
          'https://cdn.jsdelivr.net/npm/@easepick/core@1.2.0/dist/index.css',
          '/',
        ],
        AmpPlugin: {
          dropdown: {
            months: true,
            years: true,
          },
          resetButton: true,
          darkMode: false,
        },
        zIndex: 9999,
        lang: document.querySelector('html')?.getAttribute('data-locale')?.replace('_', '-') || 'en',
        plugins: [AmpPlugin],
      }

      if (startDateInput != null) {
        // Create separate datepicker for Start Date
        new easepick.create({
          ...commonOptions,
          element: startDateInput,
          setup(picker) {
            picker.on('select', () => {
              const selectedDate = picker.getDate();

              // Check if it's before today
              if (selectedDate < today) {
                errorSpan.textContent = `${window.globals.trans('cart.quote.rental_start_date_error')}`;
                errorSpan.style.display = 'inline-block';
                startDateInput.parentNode.insertBefore(errorSpan, startDateInput.nextSibling);
                startDateInput.value = '';
                endDateInput.value = '';
                return;
              }

              // Remove existing error if any
              const existingStartError = startDateInput.parentNode.querySelector('.error-message');
              if (existingStartError) existingStartError.remove();

              // Format and display date as dd/mm/yyyy
              const day = String(selectedDate.getDate()).padStart(2, '0');
              const month = String(selectedDate.getMonth() + 1).padStart(2, '0');
              const year = selectedDate.getFullYear();
              startDateInput.value = `${day}/${month}/${year}`;
            });
          },
        })
        startDateInput.removeAttribute('readonly')
        startDateInput.classList.add('calendar-icon');
        blockAllManualInput(startDateInput)
      }

      // Create separate datepicker for End Date
      if (endDateInput != null) {
        new easepick.create({
          ...commonOptions,
          element: endDateInput,
          setup(picker) {
            picker.on('select', () => {
              const selectedEndDate = picker.getDate();
              const start = parseDateFromDDMMYYYY(startDateInput.value);
              start.setHours(0, 0, 0, 0);
              const end = picker.getDate()?.format('YYYY-MM-DD') || ''

              if (picker.getDate() < start || start == 'Invalid Date') {
                endDateInput.parentNode.insertBefore(errorSpanEnd, endDateInput.nextSibling);
                errorSpanEnd.textContent = `${window.globals.trans('cart.quote.rental_end_date_error')}`;
                errorSpanEnd.style.display = 'inline-block';
                endDateInput.value = '';
                return false
              } else {
                const existingEndError = endDateInput.parentNode.querySelector('.error-message');
                if (existingEndError) existingEndError.remove();
              }

              // Format and display date as dd/mm/yyyy
              const day = String(selectedEndDate.getDate()).padStart(2, '0');
              const month = String(selectedEndDate.getMonth() + 1).padStart(2, '0');
              const year = selectedEndDate.getFullYear();
              endDateInput.value = `${day}/${month}/${year}`;
            })
          },
        })
        endDateInput.removeAttribute('readonly')
        endDateInput.classList.add('calendar-icon');
        blockAllManualInput(endDateInput)
      }
    })
  })(jQuery)
